<span [style.color]="statusColour(campaignStatus.identifier)" [style.fontWeight]="campaignStatus.identifier == 'scheduled'">{{ campaignStatus?.value }}</span>